import PreviewLayout from "./preview-layout";
import type { FlowSection } from "../form-builder/types";
import type { BrandKit } from "@/modules/brand";

interface PreviewRatingProps {
	id: string;
	section: FlowSection;
	brandkit: BrandKit;
	brandName: string;
	brandLogo: string | null;
	isSelected: boolean;
	onTitleChange?: (title: string) => void;
	onDescriptionChange: (description: string) => void;
	isDarkMode?: boolean;
}

export default function PreviewRating({ id, section, brandName, brandkit, brandLogo, isSelected, onTitleChange, onDescriptionChange, isDarkMode = false }: PreviewRatingProps) {
	void isSelected;

	const handleTitleChange = (title: string) => {
		if (onTitleChange) {
			onTitleChange(title);
		}
	};

	return (
		<PreviewLayout
			id={id}
			brandName={brandName}
			brandLogo={brandLogo}
			brandkit={brandkit}
			title={section.title}
			titlePlaceholder="How was your experience?"
			subtitle={section.description}
			subtitlePlaceholder="Add a description..."
			editableTitle
			editableSubtitle
			onLocalTitleChange={handleTitleChange}
			onLocalSubtitleChange={onDescriptionChange}
			isDarkMode={isDarkMode}
		>
			{/* Star rating preview */}
			<div className="flex items-center justify-start gap-1 md:gap-2">
				{[1, 2, 3, 4, 5].map((star) => (
					<div key={star} className="p-1 cursor-not-allowed">
						<svg
							className={`w-12 h-12 md:w-14 md:h-14 ${isDarkMode ? "text-gray-600" : "text-gray-300"}`}
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							strokeWidth={1.5}
							strokeLinecap="round"
							strokeLinejoin="round"
						>
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
						</svg>
					</div>
				))}
			</div>
		</PreviewLayout>
	);
}
